<template lang="pug">

</template>

<script>

export default {
  name: "Pins",
  data() {
    return {
      
    };
  },
  components: {

  }
};
</script>

<style scoped lang="sass">

</style>
